import { ReactNode } from 'react';

interface IBasicCard {
  children: ReactNode;
  radius?: 'lg' | 'md';
  active?: boolean;
}

const BasicCard = (props: IBasicCard) => {
  const { children, radius, active = false } = props;

  return (
    <div
      style={{ borderRadius: radius === 'lg' ? '1.5rem' : radius === 'md' ? '0.5rem' : '0.5rem' }}
      className={`h-full w-full border-[1px] p-2 ${active ? 'border-gray-400 bg-gradient-to-t from-secondary to-primary' : 'border-card-border-color bg-card-bg-color'}`}
    >
      <div
        style={{
          borderRadius: radius === 'lg' ? '1rem' : radius === 'md' ? '0.375rem' : '0.375rem',
        }}
        className="h-full w-full rounded-2xl border-[1px] border-card-border-color bg-white"
      >
        {children}
      </div>
    </div>
  );
};

export default BasicCard;
